export default __webpack_public_path__ + "static/media/dealedge2.ff4046d7.png";